import { render, staticRenderFns } from "./FtxExchangeInput.vue?vue&type=template&id=4c296bd8&"
import script from "./FtxExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./FtxExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports